import * as AddVoucherFailed from '@ori-events/add-voucher-failed';
import { RequestUrl } from '../types';
import { convertToCamelCase, getHttpRequestSettings } from '../utils';
const dispatchAddVoucherFailed = detail => {
  const event = new CustomEvent(AddVoucherFailed.Name, {
    detail
  });
  window.dispatchEvent(event);
};
export async function addVoucherHandler({
  detail: {
    placement,
    voucherCode
  }
}) {
  const fetchUrl = `${RequestUrl.AddVoucher}?voucherCode=${voucherCode}`;
  const response = await fetch(fetchUrl, getHttpRequestSettings({
    placement
  }));
  const data = convertToCamelCase(await response.json());
  if (AddVoucherFailed.isAddVoucherErrorResponse(data)) {
    dispatchAddVoucherFailed(data);
    return false;
  }
  return data;
}
//# sourceMappingURL=addVoucherHandler.js.map